import { FC, PropsWithChildren } from 'react'

type Props = {
  setFooterRef: (ref: HTMLElement | null) => void
}

const UserContactFooter: FC<PropsWithChildren<Props>> = ({
  children,
  setFooterRef
}) => {
  return (
    <div ref={setFooterRef}>
      <div className="border-t border-grey-20 p-40 pt-20 lg:px-24 sm:px-16 sm:pb-20">
        {children}
      </div>
    </div>
  )
}

export default UserContactFooter
